import { styled } from '@material-ui/core';
import { Done } from '@material-ui/icons';

import { COLORS } from 'theme/constants';

export const DoneIcon = styled(Done)({ color: COLORS.greenDeep });
